import { render, staticRenderFns } from "./ContentExplanationTable.vue?vue&type=template&id=dd9c4404&scoped=true&"
import script from "./ContentExplanationTable.vue?vue&type=script&lang=js&"
export * from "./ContentExplanationTable.vue?vue&type=script&lang=js&"
import style0 from "./ContentExplanationTable.vue?vue&type=style&index=0&id=dd9c4404&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9c4404",
  null
  
)

export default component.exports